"use client";

import { useEffect } from "react";
import { ErrorView } from "@/components/error-view";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Log the caught runtime error for diagnostics
    console.error("Root boundary caught exception:", error);
  }, [error]);

  return (
    <div className="w-full flex flex-col justify-center items-center min-h-[70vh]">
      <ErrorView code="500" error={error} reset={reset} />
    </div>
  );
}
